import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-back\"><g id=\"icon-back_asus_proart_sw_ico_arrow_back\"><rect width=\"48\" height=\"48\" style=\"fill:none\" /><path d=\"M40,25H10.41l14.3,14.29-1.42,1.42-16-16a1,1,0,0,1,0-1.42l16-16,1.42,1.42L10.41,23H40Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol